import type { ReactNode } from 'react';
import Sidebar from '../components/Sidebar.tsx';

interface Props {
  rightSidebar?: boolean;
  children: ReactNode;
  spacingClasses?: string | null;
}
export function PageContent({ children }: Props) {
  return (
    <div className={`container min-vh-100 py-4`}>
      <div className={'row'}>
        <div className={'col-lg-3 d-none d-lg-block'}>
          <Sidebar />
        </div>
        <div className={'col-lg-9 col-12'}>{children}</div>
      </div>
    </div>
  );
}

export default PageContent;
